import "./App.css";
import React from "react";
import { Redirect, Route, BrowserRouter, Switch } from "react-router-dom";
import AppLoadingDialog from "./ui/dialog/app_loading_dialog";
import Config from "./Config";
import home_screen from "./ui/screen/home_screen/home_screen";
import "./lato_font/Lato-Regular.ttf";
import "./lato_font/Lato-Bold.ttf";
import announcements_screen from "./ui/screen/announcements_screen/announcements_screen";
import announcements_detail_screen from "./ui/screen/announcements_detail_screen/announcements_detail_screen";
import claims_screen from "./ui/screen/claims_sceeen/claims_screen";
import proposal_detail_screen from "./ui/screen/proposal_detail_screen/proposal_detail_screen";
import issued_cases_detail_screen from "./ui/screen/issued_cases_detail_screen/issued_cases_detail_screen";
import certificate_collection_detail_screen from "./ui/screen/certificate_collection_detail_screen/certificate_collection_detail_screen";
import proposal_outstanding_screen from "./ui/screen/proposal_outstanding_screen/proposal_outstanding_screen";
import forms_screen from "./ui/screen/forms_screen/forms_screen";
import claims_detail_screen from "./ui/screen/claims_detail_screen/claims_detail_screen";
import login_screen from "./ui/screen/login_screen/login_screen";
import change_password_screen from "./ui/screen/login_screen/change_password_screen";
import reset_password_screen from "./ui/screen/login_screen/reset_password_screen";
import select_account_screen from "./ui/screen/select_account_screen/select_account_screen";
import profile_screen from "./ui/screen/profile_screen/profile_screen";
import submitted_documents_screen from "./ui/screen/submitted_documents_screen/submitted_documents_screen";
import AuthBloc from "./bloc/auth_bloc";
import { connect } from "react-redux";
import { setAuth, logOut } from "./data/redux/reducers/authReducer";
import connectivity_screen from "./ui/screen/connectivity_screen";
import certificate_collection_status_screen from "./ui/screen/certificate_collection_status_screen/certificate_collection_status_screen";
import business_opportunities_screen from "./ui/screen/business_opportunities_screen/business_opportunities_screen";
import proposal_screen_v2 from "./ui/screen/proposal_screen.js/proposal_screen_v2";
import issed_case_screen_v2 from "./ui/screen/issued_cases_screen/issed_case_screen_v2";
import claims_screen_v2 from "./ui/screen/claims_sceeen/claims_screen_v2";
import certificate_collection_status_screen_v2 from "./ui/screen/certificate_collection_status_screen/certificate_collection_status_screen_v2";
import certificate_collection_status_upcoming_screen from "./ui/screen/certificate_collection_status_upcoming_screen/certificate_collection_status_upcoming_screen_v2";
import business_opportunities_screen_v2 from "./ui/screen/business_opportunities_screen/business_opportunities_screen_v2";
import business_opportunities_upcoming_screen_v2 from "./ui/screen/business_opportunities_upcoming_screen/business_opportunities_upcoming_screen_v2";
import certificate_collection_status_upcoming_screen_v2 from "./ui/screen/certificate_collection_status_upcoming_screen/certificate_collection_status_upcoming_screen_v2";
import business_opportunities_detail_screen from "./ui/screen/business_opportunities_detail_screen/business_opportunities_detail_screen";
import login_screen_admin from "./ui/screen/login_screen/login_screen_admin";
import daily_reminders_screen from "./ui/screen/daily_reminders_screen/daily_reminders_screen";
import mrtt_home_screen from "./ui/screen/mrtt_home_screen/mrtt_home_screen";
import mrtt_proposal_details from "./ui/screen/mrtt_proposal_details_screen/mrtt_proposal_details";
import mrtt_proposal_screen from "./ui/screen/mrtt_proposal_screen/mrtt_proposal_screen";
import proposal_form from "./ui/screen/mrtt_proposal_screen/form";
import faq from "./ui/screen/faq_screen/faq_screen";
import faq_screen_v2 from "./ui/screen/faq_screen/faq_screen_v2";
import quotation_screen from "./ui/screen/quotation_screen/quotation_screen";
import quotation_personal_details_form from "./ui/screen/quotation_screen/form/personal_details_form";
import quotation_financing_details_form from "./ui/screen/quotation_screen/form/financing_details_form";
import quotation_takaful_details_form from "./ui/screen/quotation_screen/form/takaful_details_form";
import quotation_review_submit from "./ui/screen/quotation_screen/form/review_submit";
import quotation_details_screen from "./ui/screen/quotation_details_screen/quotation_details_screen";
import quotation_selection_screen from "./ui/screen/quotation_screen/quotation_selection_screen";
import provideDetails from "./ui/screen/mrtt_proposal_screen/form/provideDetails";
import uploadDocuments from "./ui/screen/mrtt_proposal_screen/form/uploadDocuments";
import consentAndDeclaration from "./ui/screen/mrtt_proposal_screen/form/consentAndDeclaration";
import review from "./ui/screen/mrtt_proposal_screen/form/review";
import mrtt_client_auth from "./ui/screen/mrtt_client_screen/mrtt_client_auth";
import mrtt_client_verification from "./ui/screen/mrtt_client_screen/mrtt_client_verification";
import mrtt_client_review_proposal from "./ui/screen/mrtt_client_screen/mrtt_client_review_proposal";
import mrtt_client_review_declaration from "./ui/screen/mrtt_client_screen/mrtt_client_review_declaration";
import mrtt_client_review_signature from "./ui/screen/mrtt_client_screen/mrtt_client_review_signature";
import mrtt_client_review_success from "./ui/screen/mrtt_client_screen/mrtt_client_review_success";
import mrtt_client_read_declaration from "./ui/screen/mrtt_client_screen/mrtt_client_read_declaration";
import mrtt_client_invalid from "./ui/screen/mrtt_client_screen/mrtt_client_invalid";
import mrtt_client_expired from "./ui/screen/mrtt_client_screen/mrtt_client_expired";
import { withAuth0 } from '@auth0/auth0-react';
import GeneralBloc from './bloc/general_bloc';
import Cookies from 'js-cookie';
import RouteBloc from "./bloc/route_bloc";
import JWTTokenService from "./core_library/authentication/jwt_token_service";
import UtilBloc from "./bloc/util_bloc";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      client: Config.context,
    };
  }

  async loginWithToken(token,idToken){
    try {
      let result = await AuthBloc.login(token || GeneralBloc.getAuthenticateToken(), idToken);
      if (result.success) {
        let data = result.data;
        if (data.availBanks) {
          let newData = result.data;
          if (data.availBanks.length > 0) {
            newData.roles[0].entity = result.data.availBanks[0]?.id;
            newData.roles[0].entityName = result.data.availBanks[0]?.name;
            data = newData;
          }
        }
        console.log("DATA",data)
        this.props.setAuth(data);
        this.setState({
          isAuthenticated:true
        })
        let isLogin=sessionStorage.getItem("isLogin");
        if(!isLogin){
          sessionStorage.setItem("isLogin",true)
        }else {
          sessionStorage.setItem("isLogin",false)
        }

        GeneralBloc.saveIsAuthenticate(true)
        GeneralBloc.saveAuthenticateToken(token);

        if(AuthBloc.isHeadOfBanca(data.roles[0].id)){
          //window.location.href = `/${this.state.client}/HSBC/${Config.routes.generic.home}`;
          window.location.href =`/${this.state.client}/${Config.routes.generic.account}`
        } else {
          let to="";
          let entity=data.roles[0]?.entity;
          if(entity=="AIS"){
            to="Alliance"
          } else if(entity=="MBS"){
            to="MBSB"
          } else {
            to="HSBC"
          }
          window.location.href=`/${this.state.client}/${to}/${Config.routes.generic.home}`
        }
        return true;
      } else {
        console.error("Login failed: unsuccessful result");
        await this.handleAuthFailure(new Error("Login API failed"));
        return false;
      }
    } catch (error) {
      console.error("Login failed:", error);
      await this.handleAuthFailure(error);
      return false;
    }
  }

  async handleAuthFailure(error) {
    console.error("Authentication failed:", error);

    sessionStorage.removeItem("authRetryCount");
    sessionStorage.removeItem("authFailed");

    AuthBloc.resetAuthData();
    const allCookies = Cookies.get();
    Object.keys(allCookies).forEach((cookie) => Cookies.remove(cookie));

    const { loginWithRedirect } = this.props.auth0;
    await loginWithRedirect({
      prompt: "login",
      mfa: "required",
      scope: "openid profile email"
    });
  }

  async onLogout() {
    console.log("USER LOGOUT");

    AuthBloc.resetAuthData();

    sessionStorage.removeItem("isLogin");
    sessionStorage.removeItem("authRetryCount");
    sessionStorage.removeItem("authFailed");

    const allCookies = Cookies.get();
    Object.keys(allCookies).forEach((cookie) => Cookies.remove(cookie));

    const { logout } = this.props.auth0;
    logout({ returnTo: window.location.origin, federated: true });
  }

  async componentDidMount() {
    if (this.isClientRoute()) {
      return;
    }

    const { loginWithRedirect, getAccessTokenSilently, getIdTokenClaims } = this.props.auth0;
    let isAuthenticated=Cookies.get('auth0.e1DUVicrINCjLU6hyGyWok9IcTGqr6rc.is.authenticated') || false;  

    if (!isAuthenticated) {
      await loginWithRedirect({
        prompt: "login",
        mfa: "required",
        scope: "openid profile email"
      });
    } else {
      let token = GeneralBloc.getAuthenticateToken() || null;

      if (!token) {
        try {
          token = await getAccessTokenSilently();
          const idTokenClaims = await getIdTokenClaims();
          const idToken = idTokenClaims?.__raw;

          if (token && idToken) {
            await this.loginWithToken(token, idToken);
          }
        } catch (error) {
          console.error("Token retrieval failed:", error);
          await this.handleAuthFailure(error);
        }
      } else {
        this.setState({
          isAuthenticated: true
        }, async () => {
          let isLogin = sessionStorage.getItem("isLogin");
          let session = await AuthBloc.checkSession();
          let checkedAuth0Token = true;

          if (UtilBloc.isNullOrEmpty(GeneralBloc.getAuthenticateToken())) {
            checkedAuth0Token = false;
          } else {
            checkedAuth0Token = await JWTTokenService.isValid(GeneralBloc.getAuthenticateToken());
          }

          if (UtilBloc.isNullOrEmpty(session) || !checkedAuth0Token) {
            await this.handleAuthFailure(new Error("Session invalid or token expired"));
            return;
          }

          if (isLogin === "false") {
            const idTokenClaims = await getIdTokenClaims();
            const idToken = idTokenClaims?.__raw;
            await this.loginWithToken(token, idToken);
          }
        });
      }
    }
  }

  redirectToLogin() {
    return (
      <Redirect to={`/${this.state.client}/`} />
    );
    //window.location.href = `/${Config.context}/${Config.routes.generic.login}`
  }

  //The loading state for the screen
  loadingContent() {
    return (
      <div style={{ height: "100%", width: "100%" }}>
        <AppLoadingDialog isLoading={this.state.loading} />
      </div>
    );
  }

  //The paths setup to determine which screen to display
  appContent() {
    return (
        <>
          <Route
            exact
            path={`/${this.state.client}/${Config.routes.generic.connectivity}`}
            component={connectivity_screen}
          />

          {/* ---------- Start : Enhanced Route Paths ---------- */}
          {/* 
          :entity - [HSBC,Alliance]. To identify which bank entity that is currently browsing the site
          :itemId - To identify which item is currently being viewed in this detail screen, coming from the listing page
        */}
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.home}`}
            component={home_screen}
          />
          <Route
            exact
            path={`/${this.state.client}/${Config.routes.generic.login}`}
            render={() => <Redirect to={`/${this.state.client}/`} />}
          />  
          <Route
            exact
            path={`/${this.state.client}/${Config.routes.generic.loginAdmin}`}
            component={login_screen_admin}
          />
          <Route
            exact
            path={`/${this.state.client}/${Config.routes.generic.changePassword}`}
            component={change_password_screen}
          />
          <Route
            exact
            path={`/${this.state.client}/${Config.routes.generic.resetPassword}`}
            component={reset_password_screen}
          />
          <Route
            exact
            path={`/${this.state.client}/${Config.routes.generic.account}`}
            component={select_account_screen}
          />

          {/* MRTT portal */}
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.mrtt}/${Config.routes.generic.home}`}
            component={mrtt_home_screen}
          />

          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal}`}
            component={mrtt_proposal_screen}
          />
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal}/:status`}
            component={mrtt_proposal_screen}
          />
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal_details}`}
            component={mrtt_proposal_details}
          />
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal_details}/:itemId`}
            component={mrtt_proposal_details}
          />
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal_provide_details}`}
            component={provideDetails}
          />
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal_provide_details}/:itemId`}
            component={provideDetails}
          />
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal_upload_documents}`}
            component={uploadDocuments}
          />
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal_upload_documents}/:itemId`}
            component={uploadDocuments}
          />
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal_review}`}
            component={review}
          />
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal_review}/:itemId`}
            component={review}
          />
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal_consent_declaration}`}
            component={consentAndDeclaration}
          />
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal_consent_declaration}/:itemId`}
            component={consentAndDeclaration}
          />

          {/* Quotation */}
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation}`}
            component={quotation_screen}
          />
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation}/:status`}
            component={quotation_screen}
          />
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation_details}/:itemId`}
            component={quotation_details_screen}
          />
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation_personal_details}`}
            component={quotation_personal_details_form}
          />
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation_personal_details}/:itemId`}
            component={quotation_personal_details_form}
          />
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation_financial_details}`}
            component={quotation_financing_details_form}
          />
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation_financial_details}/:itemId`}
            component={quotation_financing_details_form}
          />
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation_takaful_details}`}
            component={quotation_takaful_details_form}
          />
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation_takaful_details}/:itemId`}
            component={quotation_takaful_details_form}
          />
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation_review_submit}`}
            component={quotation_review_submit}
          />
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation_review_submit}/:itemId`}
            component={quotation_review_submit}
          />
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation_selection}`}
            component={quotation_selection_screen}
          />

          {/* FAQ */}
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.mrtt}/${Config.routes.generic.faq}`}
            component={faq}
          />
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.mrtt}/${Config.routes.generic.faq}/:section`}
            component={faq_screen_v2}
          />

          {/* Listing Page */}
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.announcement}`}
            component={announcements_screen}
          />
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.proposal}`}
            component={proposal_screen_v2}
          />
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.issuedCase}`}
            component={issed_case_screen_v2}
          />
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.certificateCollection}`}
            component={certificate_collection_status_screen_v2}
          />

          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.certificateCollectionUpcoming}`}
            component={certificate_collection_status_upcoming_screen_v2}
          />

          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.claim}`}
            component={claims_screen_v2}
          />
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.form}`}
            component={forms_screen}
          />
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.profile}`}
            component={profile_screen}
          />
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.businessOpportunity}`}
            component={business_opportunities_screen_v2}
          />

          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.businessOpportunityUpcoming}`}
            component={business_opportunities_upcoming_screen_v2}
          />

          {/* Detail Page */}
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.dailyReminder}`}
            component={daily_reminders_screen}
          />
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.announcement}/:itemId`}
            component={announcements_detail_screen}
          />
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.proposal}/:itemId`}
            component={proposal_detail_screen}
          />
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.document}/submitted/:itemId/:docClass`}
            component={submitted_documents_screen}
          />
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.issuedCase}/:itemId`}
            component={issued_cases_detail_screen}
          />

          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.businessOpportunity}/:itemId`}
            component={business_opportunities_detail_screen}
          />

          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.businessOpportunityUpcoming}/:itemId`}
            component={business_opportunities_detail_screen}
          />

          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.certificateCollection}/:itemId`}
            component={certificate_collection_detail_screen}
          />

          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.certificateCollectionUpcoming}/:itemId`}
            component={certificate_collection_detail_screen}
          />

          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.claim}/:itemId`}
            component={claims_detail_screen}
          />
          <Route
            exact
            path={`/${this.state.client}/${Config.routes.generic.account}`}
            component={select_account_screen}
          />
          <Route
            exact
            path={`/${this.state.client}/:entity/${Config.routes.generic.profile}/:itemId`}
            component={profile_screen}
          />

          {/* Home Page */}
          <Route
            exact
            path="/"
            render={() => {
              return (
                <Redirect
                  to={`/${this.state.client}/HSBC/${Config.routes.generic.home}`}
                />
              );
            }}
            // component={mrtt_home_screen}
          />
          {/* http://localhost:3000/portal/HSBC/home
        http://localhost:3000/portal/HSBC/announcement/10101 */}
          <Route
            exact
            path={`/${this.state.client}/`}
            render={() => {
              return (
                <Redirect
                  to={`/${this.state.client}/HSBC/${Config.routes.generic.home}`}
                />
              );
            }}
          />
          {/* ---------- End : Enhanced Route Paths ---------- */}
        </>
    );
  }

  clientContent() {
    return (
      <>
        {/* Client View - No Auth0 required */}
        <Route
          exact
          path={`/${this.state.client}/${Config.routes.generic.fwd + Config.routes.generic.mrtt}/${Config.routes.generic.client_auth}`}
          component={mrtt_client_auth}
        />
        <Route
          exact
          path={`/${this.state.client}/${Config.routes.generic.fwd + Config.routes.generic.mrtt}/${Config.routes.generic.client_auth}/:itemId`}
          component={mrtt_client_auth}
        />
        <Route
          exact
          path={`/${this.state.client}/${Config.routes.generic.fwd + Config.routes.generic.mrtt}/${Config.routes.generic.invalid}`}
          component={mrtt_client_invalid}
        />
        <Route
          exact
          path={`/${this.state.client}/${Config.routes.generic.fwd + Config.routes.generic.mrtt}/${Config.routes.generic.expired}`}
          component={mrtt_client_expired}
        />
        <Route
          exact
          path={`/${this.state.client}/${Config.routes.generic.fwd + Config.routes.generic.mrtt}/${Config.routes.generic.client_otp}/:itemId`}
          component={mrtt_client_verification}
        />
        <Route
          exact
          path={`/${this.state.client}/${Config.routes.generic.fwd + Config.routes.generic.mrtt}/${Config.routes.generic.client_review_proposal}/:itemId`}
          component={mrtt_client_review_proposal}
        />
        <Route
          exact
          path={`/${this.state.client}/${Config.routes.generic.fwd + Config.routes.generic.mrtt}/${Config.routes.generic.client_review_declaration}/:itemId`}
          component={mrtt_client_review_declaration}
        />
        <Route
          exact
          path={`/${this.state.client}/${Config.routes.generic.fwd + Config.routes.generic.mrtt}/${Config.routes.generic.client_review_signature}/:itemId`}
          component={mrtt_client_review_signature}
        />
        <Route
          exact
          path={`/${this.state.client}/${Config.routes.generic.fwd + Config.routes.generic.mrtt}/${Config.routes.generic.client_review_success}/:itemId`}
          component={mrtt_client_review_success}
        />
        <Route
          exact
          path={`/${this.state.client}/${Config.routes.generic.fwd + Config.routes.generic.mrtt}/${Config.routes.generic.client_review_read_declaration}/:itemId`}
          component={mrtt_client_read_declaration}
        />
      </>
    );
  }

  isClientRoute() {
    const path = window.location.pathname;
    const clientPrefix = `/${this.state.client}/${Config.routes.generic.fwd + Config.routes.generic.mrtt}/`;
    return path.includes(clientPrefix + Config.routes.generic.client_auth) ||
           path.includes(clientPrefix + Config.routes.generic.invalid) ||
           path.includes(clientPrefix + Config.routes.generic.expired) ||
           path.includes(clientPrefix + Config.routes.generic.client_otp) ||
           path.includes(clientPrefix + Config.routes.generic.client_review_proposal) ||
           path.includes(clientPrefix + Config.routes.generic.client_review_declaration) ||
           path.includes(clientPrefix + Config.routes.generic.client_review_signature) ||
           path.includes(clientPrefix + Config.routes.generic.client_review_success) ||
           path.includes(clientPrefix + Config.routes.generic.client_review_read_declaration);
  }

  render() {
    const {logout ,user } = this.props.auth0;
    if (this.isClientRoute()) {
      return this.clientContent();
    }
    return this.state.isAuthenticated === true
      ? this.appContent()
      : this.loadingContent();
  }
}

const mapStateToProps = (state) => ({
  userGlobal: state.user.value,
});

const mapDispatchToProps = { setAuth, logOut };

export default withAuth0(connect(mapStateToProps, mapDispatchToProps)(App));
